/**
 * DD-MODAL-0723 — the mobile player modal's session-level cache, extracted
 * to a dependency-free module so mutation surfaces can invalidate it
 * without importing the fetch hook (no apiService/axios dependency, and no
 * collision with the desktop-hook-name sentinels).
 *
 * The cache holds OWNERSHIP-BEARING payloads (league_context). Every
 * mutation success path (add, drop, trade, claim submit, plan execute)
 * MUST call invalidatePlayer/invalidateLeaguePlayers — the Ty France
 * incident (2026-07-23) was this cache serving a pre-add "free agent"
 * payload for a just-rostered player. Enforced by
 * src/__tests__/playerOwnership.architecture.test.js.
 */

export const playerCache = new Map();
export const cacheTimestamps = new Map();
export const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

export const cacheKeyFor = (leagueId, playerId) => `${leagueId}-${playerId}`;

/** Drop one player's cached payload (ownership changed). */
export const invalidatePlayer = (leagueId, playerId) => {
  const key = cacheKeyFor(leagueId, playerId);
  playerCache.delete(key);
  cacheTimestamps.delete(key);
};

/**
 * League-wide variant for mutations whose full player set isn't known at
 * the call site (drop-shuffle plans touch candidate + dropped player;
 * trades touch many). Clears every cached player in the league.
 */
export const invalidateLeaguePlayers = (leagueId) => {
  const prefix = `${leagueId}-`;
  for (const key of Array.from(playerCache.keys())) {
    if (key.startsWith(prefix)) {
      playerCache.delete(key);
      cacheTimestamps.delete(key);
    }
  }
};
